module.exports = __webpack_public_path__ + "img/2-5.8baa6512.svg";